import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import ResponseError from '../../../models/ResponseError';

import validation from '../../../utils/validation';

import AwbInfoSearchComponent from './AwbInfoSearchComponent';

interface AwbInfoSearchContainerProps {
  search: (awbNumber: string) => void;
  receiveError: (error: ResponseError) => void;
  label: string;
  type: string;
  buttonState: boolean;
};

interface AwbInfoSearchContainerState { 
  awbNumber: string;
};

class AwbInfoSearchContainer extends Component <AwbInfoSearchContainerProps, AwbInfoSearchContainerState> {

  state: AwbInfoSearchContainerState = {
    awbNumber: '',
  }
    
  handleChangeAwb = (event: any): void => {
   
    let value: string = event.target.value.toString();

    if (value.length === 3 && this.state.awbNumber.length === 2) {
      value = value + '-'; 
    }
    if (value.length === 11) {
      if (value.indexOf('-') < 0) {
        value = value.slice(0 , 3) + '-' + value.slice(3);
      }
    }
    if (value.split('-').length > 2) {
      return;
    }
    this.setState({ awbNumber: value }); 
  }

  search = (): void => {
    if (validation.validateAWB(this.state.awbNumber)) {
      this.props.search(this.state.awbNumber);
    } else {
      let errObj: ResponseError = {
        errorCode: '',
        longDescription: 'The entered value should contain a code (3 digits) and a number (8 digits) separated by a dash (-)!'
      }
      this.props.receiveError(errObj);
    };
  } 

  render() {
    return (
      <AwbInfoSearchComponent
        awbNumber={ this.state.awbNumber }
        label= { this.props.label }
        handleChangeAwbNumber={ this.handleChangeAwb }
        search={ this.search }
        type= { this.props.type }
        buttonState={ this.props.buttonState }
      />
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    buttonState: state.buttonState
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AwbInfoSearchContainer);